/**
 * @copyright Copyright 2023 Epic Systems Corporation
 * @file Enter pip icon
 * @author Arun Vasireddy
 * @module Epic.VideoApp.Icons.EnterPiP
 */

import React, { FC } from "react";
import { IconProps } from ".";
import styles from "../styles/_directional.scss";

/**
 * The EnterPiP component
 * @param props The props ;)
 */
const EnterPiP: FC<IconProps> = (props) => {
	//const iconClassName = resolveClassName(styles, { [chevronDirection ?? "down"]: true }, className);
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="30"
			height="30"
			viewBox="-2 -3.75 20 20"
			className={styles["flipWithPage"]}
			{...props}
		>
			<g id="White_PIP_In" data-name="White PIP In" transform="translate(-47.511 -21.764)">
				<path
					id="Path_5"
					data-name="Path 5"
					d="M13.779,5.055V-.025H-.005V10.654H5.347"
					transform="translate(48.016 22.289)"
					fill="none"
					strokeLinejoin="round"
					strokeWidth="1.5"
				/>
				<g id="arrowsbidirectional" transform="translate(36.619 32.116)">
					<path
						id="Path_2"
						data-name="Path 2"
						d="M5.631,1.989,3.7.056a.191.191,0,0,0-.327.135V1.531H.187A.191.191,0,0,0,0,1.722v.8a.191.191,0,0,0,.187.191H3.375V4.041a.191.191,0,0,0,.327.135L5.631,2.244A.187.187,0,0,0,5.631,1.989Z"
						transform="translate(14.385 -9.853) rotate(45)"
						stroke="none"
					/>
				</g>
				<g
					id="Rectangle_4"
					data-name="Rectangle 4"
					transform="translate(54.5 28.462)"
					strokeLinejoin="round"
					strokeWidth="1"
				>
					<rect width="9" height="6" stroke="none" />
					<rect x="0.5" y="0.5" width="8" height="5" fill="none" />
				</g>
			</g>
		</svg>
	);
};

EnterPiP.displayName = "EnterPiP";

export default React.memo(EnterPiP);
